<template>
  <div style="height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 100%">
        <el-row class="filter-bar" ref="filterBar">
          <el-select v-model="formDatas.agoStatus" size="mini" clearable placeholder="状态" style="width: 130px" @change="partserch">
            <el-option v-for="(name, key) in agoStatusMap" :key="key" :label="name" :value="Number(key)"></el-option>
          </el-select>
          <el-input v-model="formDatas.phone" style="width: 140px;" size="mini" placeholder="用户手机号" clearable></el-input>
          <el-input v-model="formDatas.agoOrderNo" style="width: 180px;" size="mini" placeholder="平台订单号" clearable></el-input>
          <el-input v-model="formDatas.goodsId" style="width: 100px;" size="mini" placeholder="商品id" clearable></el-input>
          <el-input v-model="formDatas.asId" style="width: 100px;" size="mini" placeholder="商户id" clearable></el-input>
          <el-input v-model="formDatas.couponId" style="width: 150px;" size="mini" placeholder="微信券id" clearable></el-input>
          <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch" style="">搜索</el-button>
          <el-button type="success" size="mini" style="" @click="Out">导出</el-button>
          </div>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            row-key-field-name="agoId" style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
      <!-- 订单详情 -->
      <el-dialog title="订单详情" :visible.sync="detailDialog" width="55%">
        <el-descriptions :column="2" size="mini" border>
          <el-descriptions-item label="平台订单号">{{ detailRow.agoOrderNo }}</el-descriptions-item>
          <el-descriptions-item label="订单id">{{ detailRow.agoId }}</el-descriptions-item>
          <el-descriptions-item label="商品">{{ detailRow.goodsName }}({{ detailRow.goodsSku }})</el-descriptions-item>
          <el-descriptions-item label="商品价格(分)">{{ detailRow.goodsPrice }}</el-descriptions-item>
          <el-descriptions-item label="商户">{{ detailRow.asName }}({{ detailRow.asId }})</el-descriptions-item>
          <el-descriptions-item label="子商户号">{{ detailRow.subMchid }}</el-descriptions-item>
          <el-descriptions-item label="用户手机号">{{ detailRow.phone }}</el-descriptions-item>
          <el-descriptions-item label="用户openid">{{ detailRow.openid }}</el-descriptions-item>
          <el-descriptions-item label="微信批次号">{{ detailRow.stockId }}</el-descriptions-item>
          <el-descriptions-item label="微信券id">{{ detailRow.couponId }}</el-descriptions-item>
          <el-descriptions-item label="微信支付商户单号">{{ detailRow.wxOutTradeNo }}</el-descriptions-item>
          <el-descriptions-item label="微信支付单号">{{ detailRow.wxTransactionId }}</el-descriptions-item>
          <el-descriptions-item label="扣减权益金(分)">{{ detailRow.agoAmount }}</el-descriptions-item>
          <el-descriptions-item label="分账比例">{{ detailRow.agoShareRatio ? (detailRow.agoShareRatio / 100).toFixed(2) + '%' : '-' }}</el-descriptions-item>
          <el-descriptions-item label="领取组号">{{ detailRow.agoClaimNo || '-' }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ agoStatusMap[detailRow.agoStatus] }}</el-descriptions-item>
          <el-descriptions-item label="核销时间">{{ detailRow.agoExchangeTime }}</el-descriptions-item>
          <el-descriptions-item label="兑换时间">{{ detailRow.createtime }}</el-descriptions-item>
          <el-descriptions-item label="失败原因" :span="2">{{ detailRow.failReason || '-' }}</el-descriptions-item>
        </el-descriptions>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefGoodsOrderList, getAjefGoodsOrderDetail, revokeAjefGoodsOrder } from "../../api/api";
export default {
  name: "GoodsOrder",
  data() {
    return {
      agoStatusMap: { 5: '待领取', 1: '已兑换待使用', 2: '已核销', 3: '已撤销/已退款', 4: '发券失败', 6: '已关闭' },
      tableLoading: false,
      totalCount: 0,
      tableHight: 520,
      tableData: [],
      detailDialog: false,
      detailRow: {},
      cellStyleOption: {
        headerCellClass: ({ rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      formDatas: {
        agoStatus: null,
        phone: '',
        agoOrderNo: '',
        goodsId: '',
        asId: '',
        couponId: '',
        currentPage: 1,
        pageSize: 20
      },
      columns: [
        { field: "", key: "a", title: "序号", width: 50, align: "center", renderBodyCell: ({ rowIndex }, h) => { return ++rowIndex; } },
        { field: "agoOrderNo", key: "agoOrderNo", title: "平台订单号", width: 160, align: "center" },
        { field: "goodsName", key: "goodsName", title: "商品", width: 160, align: "center", ellipsis: true },
        { field: "asName", key: "asName", title: "商户", width: 160, align: "center", ellipsis: true },
        { field: "phone", key: "phone", title: "用户手机号", width: 110, align: "center" },
        { field: "couponId", key: "couponId", title: "微信券id", width: 130, align: "center", ellipsis: true },
        { field: "wxTransactionId", key: "wxTransactionId", title: "微信支付单号", width: 140, align: "center", ellipsis: true },
        { field: "agoAmount", key: "agoAmount", title: "扣减权益金(分)", width: 110, align: "center" },
        { field: "agoStatus", key: "agoStatus", title: "状态", width: 110, align: "center",
          renderBodyCell: ({ row }, h) => {
            const typeMap = { 5: 'warning', 1: '', 2: 'success', 3: 'info', 4: 'danger', 6: 'info' };
            return <el-tag size="mini" type={typeMap[row.agoStatus] || 'info'}>{this.agoStatusMap[row.agoStatus]}</el-tag>;
          } },
        { field: "agoExchangeTime", key: "agoExchangeTime", title: "核销时间", width: 150, align: "center" },
        { field: "createtime", key: "createtime", title: "兑换时间", width: 150, align: "center" },
        { field: "", key: "d", title: "操作", width: 130, align: "center", fixed: 'right',
          renderBodyCell: ({ row }, h) => {
            return (
              <div>
                <el-button type="text" size="mini" on-click={() => this.showDetail(row)}>详情</el-button>
                {row.agoStatus === 1 ? (
                  <el-button type="text" size="mini" style="color:#F56C6C" on-click={() => this.revokeRow(row)}>撤销</el-button>
                ) : null}
              </div>
            );
          } },
      ],
    };
  },
  created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = calcTableHeight(this, this.windheight, 140);
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      const params = { ...this.formDatas };
      ['phone', 'agoOrderNo', 'goodsId', 'asId', 'couponId'].forEach(k => { if (params[k] === '') delete params[k]; });
      getAjefGoodsOrderList(params).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    showDetail(row) {
      getAjefGoodsOrderDetail({ agoId: row.agoId }).then((res) => {
        this.detailRow = res.data || {};
        this.detailDialog = true;
      });
    },
    revokeRow(row) {
      this.$prompt('撤销将作废用户微信券并回退权益金(已核销订单不可撤),请输入撤销原因', '确认撤销订单', {
        confirmButtonText: '确定撤销',
        cancelButtonText: '取消',
        type: 'warning',
        inputPlaceholder: '撤销原因(必填)',
        inputValidator: (value) => { return !!value || '请输入撤销原因'; }
      }).then(({ value }) => {
        this.openLoading();
        revokeAjefGoodsOrder({ agoId: row.agoId, reason: value }).then((res) => {
          this.loadings.close();
          this.$message.success('已撤销');
          this.getList();
        }).catch(() => {
          this.loadings.close();
        });
      }).catch(() => { });
    },
    Out() {
      var s = qs.stringify({ agoStatus: this.formDatas.agoStatus, asId: this.formDatas.asId });
      this.openLoading();
      var that = this;
      axios({
        method: 'post',
        url: config.baseURL + '/ajef-goods-order/exportAjefGoodsOrder',
        data: s,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'useref': window.localStorage.getItem('Qy_token')
        }
      }).then(res => {
        that.loadings.close();
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('href', objectUrl);
        a.setAttribute('download', '微信单品券兑换订单.xlsx');
        a.click();
        URL.revokeObjectURL(objectUrl);
      }).catch(() => {
        that.loadings.close();
      });
    },
    openLoading() {
      this.loadings = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
  },
};
</script>

<style scoped>
</style>
